'use es6';

import { useCallback, useMemo, memo, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import debounce from 'transmute/debounce';
import UISearchInput from 'UIComponents/input/UISearchInput';
import { GYPSUM } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const SearchWrapper = styled.div.withConfig({
  displayName: "CalleeSearchInput__SearchWrapper",
  componentId: "sc-8yugam-0"
})(["background-color:", ";"], GYPSUM);
function CalleeSearchInput({
  onClear,
  onSearch,
  setSearchText,
  searchText
}) {
  const debouncedSearchRef = useRef(null);
  const debouncedSearch = useMemo(() => {
    return debounce(500, value => {
      const trimmedValue = value.trim();
      if (!trimmedValue) {
        onClear();
      } else if (trimmedValue.length >= 3) {
        onSearch({
          query: trimmedValue,
          timestamp: Date.now()
        });
      } else {
        setSearchText(trimmedValue);
      }
    });
  }, [onClear, onSearch, setSearchText]);
  debouncedSearchRef.current = debouncedSearch;
  const handleSearchChange = useCallback(({
    target: {
      value
    }
  }) => debouncedSearchRef.current(value), []);
  return /*#__PURE__*/_jsx(SearchWrapper, {
    className: "p-all-3",
    children: /*#__PURE__*/_jsx(UISearchInput, {
      onChange: handleSearchChange,
      defaultValue: searchText,
      use: "on-dark",
      "data-selenium-test": "callees-search-input"
    })
  });
}
CalleeSearchInput.propTypes = {
  onClear: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  setSearchText: PropTypes.func.isRequired,
  searchText: PropTypes.string
};
export default /*#__PURE__*/memo(CalleeSearchInput);